exports = module.exports = require("../../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".m-chatpanel-buttons .buttons {\n  margin-top: 6px; }\n  .m-chatpanel-buttons .buttons .btn {\n    height: 24px;\n    line-height: 24px;\n    padding: 0 12px;\n    color: #00ACE6;\n    background: #fff;\n    border-radius: 12px;\n    display: inline-block;\n    font-size: 12px;\n    margin-right: 2px; }\n    .m-chatpanel-buttons .buttons .btn.disabled {\n      color: rgba(0, 172, 230, 0.5); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.25.0@css-loader??ref--3-1!./node_modules/_sass-loader@4.0.2@sass-loader??ref--3-2!./node_modules/_postcss-loader@1.3.3@postcss-loader??ref--3-3!./src/app/extension/buttons/style.scss
// module id = 334
// module chunks = 0 1